import { AddressModel } from '@utmost.co/enterprise-models';
import { useUtilsIntl } from './translations/useUtilsIntl';

export const useFormatAddressAsSingleLine = () => {
  const intl = useUtilsIntl();

  return (address: DeepPartial<AddressModel> | string | undefined, showTimezone?: boolean) => {
    if (typeof address === 'string') return address;

    const timeZoneLocale = intl.timeZone ?? 'Time Zone';
    const lines = address?.lines?.map((item) => item?.value ?? '').filter((l) => !!l);
    const prefix = lines?.length ? '\n' : '';
    const list = [
      ...(lines ?? []),
      address?.municipality ? prefix + address.municipality : '',
      address?.region ?? '',
      address?.postCode ?? '',
      address?.countryCode ? `\n${address.countryCode}` : '',
      showTimezone && address?.timeZone ? `\n${timeZoneLocale}: ${address.timeZone}` : ''
    ].filter((a) => a !== '');
    return list.join(', ');
  };
};
